export default "__VITE_ASSET__f1aa85a3__"